"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

function registerEvent(ref, event, callback) {
  if (ref && callback) {
    ref.addEventListener(event, callback);
  }
}

function unregisterEvent(ref, event, callback) {
  if (ref && callback) {
    ref.removeEventListener(event, callback);
  }
}

var LottieAnimate = function LottieAnimate(_ref) {
  var path = _ref.path,
      _ref$loop = _ref.loop,
      loop = _ref$loop === void 0 ? false : _ref$loop,
      _ref$autoPlay = _ref.autoPlay,
      autoPlay = _ref$autoPlay === void 0 ? true : _ref$autoPlay,
      onComplete = _ref.onComplete,
      onError = _ref.onError,
      onDataFailed = _ref.onDataFailed,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["path", "loop", "autoPlay", "onComplete", "onError", "onDataFailed"]);
  var ref = (0, _react.useRef)();

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useRef = (0, _react.useRef)(!!window.lottie),
      isLoaded = _useRef.current;

  var lottieRef = (0, _react.useRef)();
  var loadLottie = (0, _react.useCallback)(function () {
    if (!lottieRef.current) {
      lottieRef.current = window.lottie.loadAnimation({
        path: path,
        loop: loop,
        autoPlay: false,
        renderer: 'svg',
        container: ref.current
      });
      registerEvent(lottieRef.current, 'complete', onComplete);
      registerEvent(lottieRef.current, 'error', onError);
      registerEvent(lottieRef.current, 'data_failed', onDataFailed); // Trigger the animation after binding the `complete` event

      if (autoPlay) {
        // $FlowFixMe
        lottieRef.current.play();
      }
    }

    return function () {
      unregisterEvent(lottieRef.current, 'complete', onComplete);
      unregisterEvent(lottieRef.current, 'error', onError);
      unregisterEvent(lottieRef.current, 'data_failed', onDataFailed);
      lottieRef.current = undefined;
    };
  }, [autoPlay, onComplete, onError, onDataFailed]);
  (0, _react.useEffect)(function () {
    if (isLoaded) {
      loadLottie();
    } else {
      var script = document.createElement('script');
      script.onload = loadLottie;
      script.type = 'text/javascript';
      document.body.appendChild(script);
      script.src = t('lottie_light.min.js');
      return function () {
        document.body.removeChild(script);
      };
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    ref: ref
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(LottieAnimate);

exports["default"] = _default;
//# sourceMappingURL=index.js.map